import { memo, useMemo } from "react";
import { Grid } from "@mui/material";
import MxTypography from "@rf-l1/MxTypography";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import MxFormL3RushCounterField from "@rf-l3/form/MxFormL3Counter";
import { checkFeatureIndicator } from "../../../../util/model/feature-indicators";
import { usePropertyFormFeaturesState } from "../../../../store/slices/FormFeaturesSlice";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";
import usePropertyFormHelp from "../../../../hooks/helps/usePropertyFormHelp";
const FeatureEnvironment = () => {
  const { PROPERTY_TYPE_ID } = usePropertyFormHelp();
  const { feature } = usePropertyFormFeaturesState();
  const SHOW = useMemo(
    () => ({
      bedrooms: checkFeatureIndicator(PROPERTY_TYPE_ID!, "bedrooms"),
      bathrooms: checkFeatureIndicator(PROPERTY_TYPE_ID!, "bathrooms"),
      halfBathrooms: checkFeatureIndicator(PROPERTY_TYPE_ID!, "halfBathrooms"),
      parkingSpots: checkFeatureIndicator(PROPERTY_TYPE_ID!, "parkingSpots"),
      pumps: checkFeatureIndicator(PROPERTY_TYPE_ID!, "pumps"),
      levelFloor: checkFeatureIndicator(PROPERTY_TYPE_ID!, "levelFloor"),
      totalLevels: checkFeatureIndicator(PROPERTY_TYPE_ID!, "totalLevels"),
      feature: checkFeatureIndicator(PROPERTY_TYPE_ID!, "feature")
    }),
    [PROPERTY_TYPE_ID]
  );

  if (
    !(
      SHOW.bathrooms ||
      SHOW.bedrooms ||
      SHOW.feature ||
      SHOW.halfBathrooms ||
      SHOW.levelFloor ||
      SHOW.pumps ||
      SHOW.parkingSpots ||
      SHOW.totalLevels
    )
  ) {
    return <div></div>;
  }

  const SHOW_ENVIRONMENTS =
    SHOW.bathrooms ||
    SHOW.bedrooms ||
    SHOW.halfBathrooms ||
    SHOW.levelFloor ||
    SHOW.pumps ||
    SHOW.parkingSpots ||
    SHOW.totalLevels;

  return (
    <Grid container columnSpacing={1} rowGap={2}>
      {SHOW.feature && (
        <Grid item xs={12}>
          <MxFormSubTitle label="Mejoras & Amenidades" />
        </Grid>
      )}

      {SHOW.feature && (
        <Grid item xs={4}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            name={CPropertyFormKeys.features_property}
            items={feature.improvements ?? []}
            isMultiple={true}
          />
        </Grid>
      )}

      {SHOW_ENVIRONMENTS && (
        <Grid item xs={12}>
          <MxFormSubTitle label="Selecciona la cantidad" />
        </Grid>
      )}

      {SHOW.bedrooms && (
        <Grid item xs={12} md={12} lg={6}>
          <MxFormL3RushCounterField
            withreacthookform={1}
            name={CPropertyFormKeys.bedrooms_property}
            label="Habitaciones"
            countRender={7}
          />
        </Grid>
      )}

      {SHOW.bathrooms && (
        <Grid item xs={12} md={12} lg={6}>
          <MxFormL3RushCounterField
            withreacthookform={1}
            name={CPropertyFormKeys.bathrooms_property}
            label="Baños"
            countRender={7}
          />
        </Grid>
      )}

      {SHOW.halfBathrooms && (
        <Grid item xs={12} md={12} lg={6}>
          <MxFormL3RushCounterField
            withreacthookform={1}
            name={CPropertyFormKeys.half_bathrooms_property}
            label="Medio baños"
            countRender={7}
          />
        </Grid>
      )}

      {SHOW.parkingSpots && (
        <Grid item xs={12} md={12} lg={6}>
          <MxFormL3RushCounterField
            withreacthookform={1}
            name={CPropertyFormKeys.parking_spots_property}
            label="Parqueo"
            countRender={7}
          />
        </Grid>
      )}
      {SHOW.levelFloor && (
        <Grid item xs={12} md={12} lg={6}>
          <MxFormL3RushCounterField
            withreacthookform={1}
            name={CPropertyFormKeys.level_floor_property}
            label="Nivel de piso"
            countRender={7}
          />
        </Grid>
      )}
      {SHOW.totalLevels && (
        <Grid item xs={12} md={12} lg={6}>
          <MxFormL3RushCounterField
            withreacthookform={1}
            name={CPropertyFormKeys.total_floor_property}
            label="Total de pisos"
            countRender={7}
          />
        </Grid>
      )}
      {SHOW.pumps && (
        <Grid item xs={12} md={12} lg={6}>
          <MxFormL3RushCounterField
            withreacthookform={1}
            name={CPropertyFormKeys.pumps_property}
            label="Bombas"
            countRender={7}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default memo(FeatureEnvironment);
